import React from "react";
import { offer } from "../data/offer";
export function SiteFooter() {
  return <footer className="bg-ink px-5 py-10 text-center text-cream" data-id="element-162" data-mp="3r8j5p2ritcpa">
      <p className="font-display text-lg font-semibold" data-id="element-163" data-mp="3raceanlp26zx">{offer.brand}</p>
      <p className="mt-2 text-xs text-cream/60" data-id="element-164" data-mp="3mg84lwl1nkv5">
        © {new Date().getFullYear()} {offer.brand}. Tous droits réservés.
      </p>
    </footer>;
}